import { zodResolver } from '@hookform/resolvers/zod'

import { companyFormSchema } from './validation'

import type { CompanyFormInput } from '../types/forms'
import type { Resolver } from 'react-hook-form'

export const companyFormResolver = zodResolver(companyFormSchema) as Resolver<CompanyFormInput>
